module.exports = __webpack_public_path__ + "img/express-flower-gel-double-large.9ecb191b.png";